import APP_CONFIG from "../../configs/environment";
import { getSessionData } from "../auth/AuthApi";

const backendURL = APP_CONFIG.amplify_config.API.endpoints[0].endpoint + "/";
export const myInitHeader = (currentSession: any, contentType?: any) => ({
  headers: {
    Authorization: `Bearer ${currentSession.getIdToken().getJwtToken()}`,
    "Content-Type": contentType || "application/json",
  },
});

export async function post(path: string, data: any) {
  const myNewInit = myInitHeader(await getSessionData());
  let myInit = {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      ...myNewInit.headers,
    },
  };
  const response = await fetch(backendURL + path, myInit);
  return response;

  // axios
  //   .post(backendURL + path, myInit)
  //   .then((response) => {
  //     return response;
  //   })
  //   .catch((e) => {
  //     console.log(e);
  //     // throw getValidErrors(e, path);
  //   });
}

export async function get(path: string) {
  try {
    const myNewInit = myInitHeader(await getSessionData());
    let myInit = {
      method: "GET",
      headers: {
        ...myNewInit.headers,
      },
    };
    const response = await fetch(backendURL + path, myInit);
    if (!response.ok) {
      throw response;
    }
    return response;
  } catch (e) {
    throw e;
  }

  // axios
  //   .get(backendURL + path, myInit)
  //   .then((response) => {
  //     return response;
  //   })
  //   .catch((e) => {
  //     console.log(e);
  //     // throw getValidErrors(e, path);
  //   });
}
